import {OfferModel, OfferVariationModel} from '@service/models';
import {UtilsService} from '@core/util-services/utils.service';

/**
 * @description Chart monthly loan balance, interest and equity in an HTML <canvas> element.
 *      If called with no arguments then just erase any previously drawn chart.
 * @param loan terms : loan amount, apr, term
 * @return monthly payment
 */
export function calcEMI(item: OfferVariationModel = new OfferVariationModel(), achOpted: boolean, includeTax = false): OfferVariationModel {
    // Convert interest from a percentage to a decimal, and convert from
    // an annual rate to a monthly rate. Convert payment period in years
    // to the number of monthly payments.
    // MonthlyPayment*(1-(1+((APR/12)/100)^-Term)/((APR/12)/100)) -- when we do not know the total loan amount
    // Default ACH applied, the ach option is auto selected on page load.
    // const _loanTerms = Object.assign({}, item);
    if (item.isLenderOfferAch && achOpted) {
        item.withAllAPR = item.apr - item.achDiscountRate;
    } else {
        item.withAllAPR = item.apr;
    }

    item.withAllAPR = Number(item.withAllAPR.toFixed(2));

    const interest = item.withAllAPR / 100 / 12;

    // compute the monthly payment figure
    const x = Math.pow(1 + interest, item.defaultTerm); // Math.pow computes powers
    let loanAmount = item.customizedLoanAmount;
    if (includeTax) {
        loanAmount += item.totalTax;
    }
    const monthly = (loanAmount * x * interest) / (x - 1);


    // If the result is a not finite number, then something wrong with input provided
    if (isFinite(monthly)) {
        // Rounding to 2 decimal places
        item.emi = monthly;
        item.totalAmount = (monthly * item.defaultTerm);
        item.totalInterest = ((monthly * item.defaultTerm) - item.customizedLoanAmount);
        item.isCalcSuccess = true;
    } else {
        // Result was Not-a-Number or infinite, which means the input was
        // incomplete or invalid. Clear any previously displayed output.
        item.isCalcSuccess = false;
    }
    return item;
}


/**
 * @description Calculate dti loan amount based on dti emi
 * @return Offer Variation
 * @param item: OfferVariationModel
 * @param achOpted
 */
export function calcDTILoanAmount(item: OfferVariationModel = new OfferVariationModel(), achOpted: boolean = false): OfferVariationModel {
    if (item.isLenderOfferAch && achOpted) {
        item.withAllAPR = item.apr - item.achDiscountRate;
    } else {
        item.withAllAPR = item.apr;
    }
    item.withAllAPR = Number(item.withAllAPR.toFixed(2));

    const interest = item.withAllAPR / 100 / 12;

    // compute the monthly payment figure
    const x = Math.pow(1 + interest, item.defaultTerm); // Math.pow computes powers

    // const monthly = ((item.customizedLoanAmount + item.totalTax) * x * interest) / (x - 1);
    item.maxDTILoanAmount = item.maxDtiEmi * (x - 1) / (x * interest);

    // item.maxDTILoanAmount = dtiLoanAmount - item.totalTax;
    return item;
}

export function copyObject(offerVariation: OfferVariationModel, obj: OfferModel, variation: OfferVariationModel): OfferVariationModel {
    const utilService = new UtilsService();
    return utilService.copyObject(offerVariation, obj, variation);
}
